import React, { useContext } from "react";
import { AppContext } from "../../App";
import Can from "../can/Can";
import { project } from "../../rbac-consts";
import { default as ClientProjectDetailsContainer } from "./client/projectDetails/ProjectDetailsContainer";

const ProjectDetailsWrapper = ({ match }) => {

  const { user } = useContext(AppContext);

  return (
    <>
      <Can
        role={user.roles}
        perform={project.USER}
        yes={() => (
          <ClientProjectDetailsContainer match={match} />
        )}
      />
    </>
  );
};

export default ProjectDetailsWrapper;